import { render, staticRenderFns } from "./ImageChoice.vue?vue&type=template&id=538e3e32&"
import script from "./ImageChoice.vue?vue&type=script&lang=js&"
export * from "./ImageChoice.vue?vue&type=script&lang=js&"
import style0 from "./ImageChoice.vue?vue&type=style&index=0&id=538e3e32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports